import { getScopedTranslate } from '@locale/translate';

import { getAllowedDaysPhrase } from './weekday-phrase';

const summaryLocale = {
  en: {
    methodEmail: 'email reminders',
    methodSms: 'SMS reminders',
    methodEmailAndSms: 'email and SMS reminders',
  },
};

export const REMINDER_SUMMARY_TEMPLATES = {
  everyDay:
    'Send up to {amount} {methods} at {time}, every day {daysPhrase} until completed. ({timezone})',
  everyNDays:
    'Send up to {amount} {methods} at {time}, every {frequency} days {daysPhrase} until completed. ({timezone})',
};

export const getMethodsPhrase = ({
  hasEmail,
  hasSms,
}: {
  hasEmail: boolean;
  hasSms: boolean;
}): string => {
  const { t } = getScopedTranslate(summaryLocale);
  if (hasEmail && hasSms) return t('methodEmailAndSms');
  if (hasEmail) return t('methodEmail');
  if (hasSms) return t('methodSms');
  return '';
};

// `action.timezone` comes through as e.g. "GMT+00:00 Atlantic/Reykjavik" — drop
// the offset and keep the IANA name for display.
export const getTimezoneName = (actionTimezone: string | undefined): string => {
  return actionTimezone?.split(' ').slice(1).join(' ') ?? '';
};

export type ReminderSummaryParts = {
  amount: string;
  methods: string;
  time: string;
  frequency: string;
  daysPhrase: string;
  timezone: string;
};

type BuildPartsArgs = {
  amount: number;
  frequency: number;
  hour: string;
  minute: string;
  allowedWeekdays: number[];
  hasEmail: boolean;
  hasSms: boolean;
  timezoneName: string;
};

export const buildReminderSummaryParts = ({
  amount,
  frequency,
  hour,
  minute,
  allowedWeekdays,
  hasEmail,
  hasSms,
  timezoneName,
}: BuildPartsArgs): ReminderSummaryParts => {
  return {
    amount: String(amount),
    methods: getMethodsPhrase({ hasEmail, hasSms }),
    time: `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`,
    frequency: String(frequency),
    daysPhrase: getAllowedDaysPhrase(allowedWeekdays),
    timezone: timezoneName,
  };
};
